  <div class="dialog-wrapper"
  cdkDrag
  cdkDragRootElement=".cdk-overlay-pane">
  
  <div class="dialog-header" cdkDragHandle>
     <span class="dialog-title"></span>
     <div class="dialog-actions">
         <button mat-icon-button class="minimize-button" (click)="minimizeDialog()" aria-label="Minimize dialog" [matTooltip]="'Minimize'">
             <mat-icon>minimize</mat-icon>
         </button>
         <button mat-icon-button class="close-button" (click)="closeDialog()" aria-label="Close dialog" [matTooltip]="'Close'">
             <mat-icon>close</mat-icon>
         </button>
     </div>
  </div>
  
  <div class="iframe-container">
     <iframe [src]="safeUrl"></iframe>
  </div>
  
  </div>